import { render } from "./ArmedIncome.vue?vue&type=template&id=fa3c5e92"
import script from "./ArmedIncome.vue?vue&type=script&lang=js"
export * from "./ArmedIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__